module.exports = __webpack_public_path__ + "media/packs/images/flags/BD-9bb25d743d1d428a288936c5b9a6ad0b.svg";